import TronWeb from 'tronweb'

// 初始化 TronWeb 实例
let tronWeb = null

const initTronWeb = () => {
  if (!tronWeb) {
    // 从本地存储获取节点设置，默认使用 TronGrid 主网
    const settings = localStorage.getItem('appSettings')
    const tronNode = settings ? JSON.parse(settings).tronNode : 'https://api.trongrid.io'
    
    // 正确的 TronWeb 初始化方式
    tronWeb = new TronWeb({
      fullNode: tronNode,
      solidityNode: tronNode,
      eventServer: tronNode
    })
  }
  return tronWeb
}

// 获取最新区块信息
export const fetchBlock = async () => {
  const tronWeb = initTronWeb()
  
  try {
    // 使用 trx.getCurrentBlock() 获取最新区块
    const block = await tronWeb.trx.getCurrentBlock()
    
    // 解析区块数据
    const blockNumber = block.block_header.raw_data.number
    const blockHash = block.blockID
    
    // 从末尾开始查找，只取数字
    let lastDigit = ''
    for (let i = blockHash.length - 1; i >= 0; i--) {
      const char = blockHash[i].toLowerCase()
      if (!isNaN(parseInt(char, 10))) {
        lastDigit = char
        break
      }
    }
    
    // 转换为数字
    const num = parseInt(lastDigit, 10) || 0
    
    // 计算大小和单双结果
    const sizeResult = num <= 4 ? '小' : '大' // 0-4小，5-9大
    const parityResult = num % 2 === 0 ? '双' : '单'
    
    return {
      blockNumber,
      blockHash,
      lastDigit,
      sizeResult,
      parityResult
    }
  } catch (error) {
    console.error('获取区块失败:', error)
    throw error
  }
}

// 测试 TRON 节点连接
export const testConnection = async (nodeUrl) => {
  try {
    const tempTronWeb = new TronWeb({
      fullNode: nodeUrl,
      solidityNode: nodeUrl,
      eventServer: nodeUrl
    })
    
    const block = await tempTronWeb.trx.getCurrentBlock()
    return {
      success: true,
      blockNumber: block.block_header.raw_data.number
    }
  } catch (error) {
    return {
      success: false,
      error: error.message
    }
  }
}

export default {
  fetchBlock,
  testConnection
}